export default __webpack_public_path__ + "static/relative-book-regular-59a627efc3ab42dadc18b3fca590d7d7.woff2";